import { fromUnixTime } from "date-fns";
import { da } from "date-fns/locale";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { FC, useState } from "react";
//@ts-ignore
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast, Zoom } from "react-toastify";
import {
  AccountSettings,
  useProductStockExportQuery,
} from "../../../Generated/graphql";
import { Button } from "../../Button/Button";
import "./SettingsDataRetrievalContent.css";

registerLocale("da", da);

type Props = {
  settings: AccountSettings;
};

export const SettingsDataRetrievalContent: FC<Props> = ({ settings }) => {
  const [startDate, setStartDate] = useState<Date>(new Date());
  const [endDate, setEndDate] = useState<Date>(new Date());

  const { data, loading } = useProductStockExportQuery({
    variables: {
      customerId: settings.id,
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    },
    skip: !settings.id,
  });

  // const handleExcelExport = () => {
  //   if (!data?.productStockExport) return;

  //   // Sort the data by takenAt date before export
  //   const sortedData = [...data.productStockExport].sort((a, b) => {
  //     const dateA = a.takenAt ? new Date(Number(a.takenAt)).getTime() : 0;
  //     const dateB = b.takenAt ? new Date(Number(b.takenAt)).getTime() : 0;
  //     return dateA - dateB; // Ascending order (oldest first)
  //   });

  //   const workbook = XLSX.utils.book_new();
  //   const worksheet = XLSX.utils.json_to_sheet(sortedData);

  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Export");
  //   XLSX.writeFile(
  //     workbook,
  //     `scanned_items_stock_export_${startDate.toISOString().split("T")[0]}_${
  //       endDate.toISOString().split("T")[0]
  //     }.xlsx`
  //   );

  //   toast("Excel export completed successfully", {
  //     className: "u-toast-success",
  //     progressClassName: "u-toast-success-bar",
  //     transition: Zoom,
  //   });
  // };

  const handlePdfExport = () => {
    if (!data?.productStockExport) return;

    // Sort the data by takenAt date before export
       const sortedData = [...data.productStockExport].sort((a, b) => {
      const dateA = a.takenAt ? new Date(Number(a.takenAt)).getTime() : 0;
      const dateB = b.takenAt ? new Date(Number(b.takenAt)).getTime() : 0;
      return dateA - dateB; // Ascending order (oldest first)
    });

    const doc = new jsPDF();

    // Add title
    doc.text("Scanned Stock Export Report", 14, 15);
    doc.text(
      `Interval: ${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`,
      14,
      25
    );

    // Prepare the data
    const tableData = sortedData.map((item) => [
      item.productNumber,
      item.description ?? '',
      item.eventAction,
      item.takenAt
        ? fromUnixTime(Number(item.takenAt) / 1000).toLocaleDateString("da")
        : "",
    ]);

    // Add the table
    autoTable(doc, {
      head: [["Produktnummer", "Beskrivelse", "Handling", "Dato",]],
      body: tableData,
      startY: 35,
      theme: "grid",
      styles: { fontSize: 8 },
      headStyles: { fillColor: [71, 71, 71] },
    });

    // Save the PDF
    doc.save(
      `scanned_items_taken_stock_export_${startDate.toISOString().split("T")[0]}_${
        endDate.toISOString().split("T")[0]
      }.pdf`
    );

    toast("PDF export completed successfully", {
      className: "u-toast-success",
      progressClassName: "u-toast-success-bar",
      transition: Zoom,
    });
  };

  return (
    <>
      <div className="SettingsDataRetrieval__Content">
        <div className="SettingsDataRetrieval__Elements">
          <div className="SettingsDataRetrieval__Element">
            <p>Startdato</p>
            <label>Vælg startdato for perioden</label>
          </div>
          <div className="SettingsDataRetrieval__Element">
            <div className="SettingsDataRetrieval__date-picker">
              <DatePicker
                selected={startDate}
                onChange={(date: Date) => setStartDate(date)}
                dateFormat="dd-MM-yyyy"
                locale="da"
              />
            </div>
          </div>

          <div className="SettingsDataRetrieval__Element">
            <p>Slutdato</p>
            <label>Vælg slutdato for perioden</label>
          </div>
          <div className="SettingsDataRetrieval__Element">
            <div className="SettingsDataRetrieval__date-picker">
              <DatePicker
                selected={endDate}
                onChange={(date: Date) => setEndDate(date)}
                dateFormat="dd-MM-yyyy"
                locale="da"
              />
            </div>
          </div>

          <div className="SettingsDataRetrieval__Element">
            <p>Eksport muligheder</p>
            <label>Vælg dit ønskede format</label>
          </div>
          <div className="SettingsDataRetrieval__Element">
            <div className="SettingsDataRetrieval__actions">
              {/* <Button
                buttonStyle="newItem"
                labelStyle="createButton"
                click={handleExcelExport}
                inactive={loading || !data?.productStockExport}
              >
                Export til Excel
              </Button> */}
              <Button
                buttonStyle="newItem"
                labelStyle="createButton"
                click={handlePdfExport}
                inactive={loading || !data?.productStockExport}
              >
                Export til PDF
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
